const stringIncludesNew = (target) => target.includes('new_');

// eslint-disable-next-line arca/no-default-export
export default stringIncludesNew;
